// 定义设置axios 请求实例
import axios from 'axios'
import {
  Message
} from 'element-ui'
// import store from '@/store'
import {
  getToken,
  removeToken
} from '@/utils/auth'
import router from '@/router'

// 设置允许跨域访问
axios.defaults.withCredentials = true

// 创建axios实例
const instance = axios.create({
  baseURL: '',
  timeout: 60000
})

// 请求拦截器
instance.interceptors.request.use(
  config => {
    // 让每个请求携带token
    config.headers['token'] = getToken()
    // 改为加载中状态
    // store.commit('showLoading')
    return config
  },
  error => {
    // console.log(error)
    Promise.reject(error)
  }
)
// 响应拦截器
instance.interceptors.response.use(function (response) {
  // 取消加载中状态
  // store.commit('hideLoading')

  // 成功的code为1
  if (!response.data.code || response.data.code !== 1) {
    Message({
      message: response.data.msg,
      type: 'error'
    })
    // 104未登录。 106token已过期，需要重新登录。107无效token。 108IP异常，需要重新登录
    if (response.data.code === 104 || response.data.code === 106 || response.data.code === 107 || response.data.code === 108) {
      // 清除token
      removeToken()
      // 需要重新登录
      router.push('/login')
      return new Promise((resolve, reject) => {
        reject(response.data.msg)
      })
    }
    // 不需要重新登录的错误，直接提示
    return new Promise((resolve, reject) => {
      reject(response.data.msg || '错误')
    })
  }
  return response
},
function (error) {
  console.log('系统报错')
  // 取消加载中状态
  // store.commit('hideLoading')
  if (error.response) {
    switch (error.response.status) {
      case 400:
        Message({
          message: error.response.data.message || '请求参数异常',
          type: 'error'
        })
        break
      case 401:
        Message({
          message: error.response.data.message || '密码错误或账号不存在！',
          type: 'warning',
          onClose: function () {
            location.reload()
          }
        })
        break
      case 403:
        Message({
          message: error.response.data.message || '无访问权限，请联系企业管理员',
          type: 'warning'
        })
        break
      default:
        Message({
          message: error.response.data.message || '服务端异常，请联系技术支持',
          type: 'error'
        })
    }
  }
  return Promise.reject(error)
})

export default instance



// WEBPACK FOOTER //
// ./src/utils/request.js